import { render, staticRenderFns } from "./moreSelect.vue?vue&type=template&id=39fbb28b&scoped=true"
import script from "./moreSelect.vue?vue&type=script&lang=js"
export * from "./moreSelect.vue?vue&type=script&lang=js"
import style0 from "./moreSelect.vue?vue&type=style&index=0&id=39fbb28b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fbb28b",
  null
  
)

export default component.exports